module.exports = __webpack_public_path__ + "static/media/stop-12.85962fe9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-12.svg
// module id = 1357
// module chunks = 0